import { render, staticRenderFns } from "@/modules/Insured/templates/insured-detail.html?vue&type=template&id=cc3bbf52&scoped=true&"
import script from "@/modules/Insured/scripts/insured-detail.ts?vue&type=script&lang=js&"
export * from "@/modules/Insured/scripts/insured-detail.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Insured/styles/insured-detail.scss?vue&type=style&index=0&id=cc3bbf52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3bbf52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
